export const SITE_HEADER = 'Lesson Completion Snapshot'
